import { Alert } from '../../types/Alert';

export const fakeAlerts: Alert[] = [
  {
    id: '1',
    sensorMacAddr: 'AA:BB:CC:DD:EE:01',
    message: 'Température trop élevée',
    timestamp: new Date(Date.now() - 1000 * 60 * 60).toISOString(),
    severity: 'critical',
    read: false,
  },
  {
    id: '2',
    sensorMacAddr: 'AA:BB:CC:DD:EE:02',
    message: 'Humidité basse',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(),
    severity: 'warning',
    read: false,
  },
  {
    id: '3',
    sensorMacAddr: 'AA:BB:CC:DD:EE:01',
    message: 'Température normale',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 3).toISOString(),
    severity: 'info',
    read: true,
  },
  {
    id: '4',
    sensorMacAddr: 'AA:BB:CC:DD:EE:01',
    message: 'Température trop élevée',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 4).toISOString(),
    severity: 'critical',
    read: false,
  },
  // Alertes pour capteurs de porte
  {
    id: '5',
    sensorMacAddr: 'ZZ:YY:XX:WW:VV:01',
    message: 'Porte restée ouverte trop longtemps',
    timestamp: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
    severity: 'critical',
    read: false,
  },
  {
    id: '6',
    sensorMacAddr: 'ZZ:YY:XX:WW:VV:02',
    message: 'Ouverture inhabituelle détectée',
    timestamp: new Date(Date.now() - 1000 * 60 * 90).toISOString(),
    severity: 'warning',
    read: false,
  },
  {
    id: '7',
    sensorMacAddr: 'ZZ:YY:XX:WW:VV:01',
    message: 'Porte restée ouverte trop longtemps',
    timestamp: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
    severity: 'critical',
    read: false,
  },
];
